import styled from 'styled-components';

const TextLabel = styled.div`
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: normal;
	line-height: normal;
	user-select: none;
`;

export { TextLabel };
